<template>
  <v-dialog
    v-model="dialog"
    max-width="500px"
    transition="dialog-bottom-transition"
    overlay-opacity="0.6"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        v-if="isBtn"
        color="error"
        class="me-4"
        name="delete"
        :title="'delete ' + id"
        :disabled="disabled"
        v-on="on"
      >
        Reset
        <v-icon
          small
          class="ms-2"
        >
          mdi-delete
        </v-icon>
      </v-btn>
      <v-icon
        v-else
        :size="size"
        class="mx-2"
        name="delete"
        :title="'delete ' + id"
        :disabled="disabled"
        v-on="on"
      >
        mdi-delete
      </v-icon>
    </template>
    <v-card
      elevation="16"
      rounded="lg"
    >
      <v-toolbar
        flat
        dense
        color="error"
        dark
      >
        <v-toolbar-title>Confirm delete</v-toolbar-title>
        <v-spacer />
        <v-btn
          icon
          @click="_onNo()"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="pa-4">
        <div class="text-subtitle-1 font-weight-medium">
          Are you sure you want to proceed?
        </div>
        <div class="text-body-2 mt-2">
          This action cannot be undone.
        </div>
      </v-card-text>

      <v-divider />

      <v-card-actions class="pa-4">
        <v-spacer />
        <v-btn
          text
          @click="_onNo()"
        >
          Cancel
        </v-btn>
        <v-btn
          color="error"
          dark
          @click="_onYes()"
        >
          Delete
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: null
    },
    size: {
      type: Number,
      default: 16
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isBtn: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialog: false
    };
  },
  created() {
    this.$emit('closeDialog');
  },
  methods: {
    _onYes() {
      this.$emit('deleted', this.id);
      this.dialog = false;
    },
    _onNo() {
      this.dialog = false;
    }
  }
};
</script>
